const B_1 = [
    {
        title: '委托合同',
        path: '/bidding/zbproject/wtht'
    }
]

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'zb-project'*/ '@layout/empty'),
    children: [
        {
            path:"wtht",
            component: () => import('@views/bidding/views/zb-project/wei-tuo-he-tong'),
            meta: {
                title: '委托合同',
                topNav: true,
                bread: B_1
            },
        }
    ]
}